export type DatabaseSchemaView = 'diagram' | 'table'

export const DATABASE_SCHEMA_VIEWS: DatabaseSchemaView[] = ['diagram', 'table']

export function databaseSchemaBasePath(databaseId: string | number): string {
  return `/databases/${databaseId}/schema`
}

export function databaseSchemaPath(
  databaseId: string | number,
  view: DatabaseSchemaView = 'diagram',
): string {
  return `${databaseSchemaBasePath(databaseId)}/${view}`
}

export function databaseSchemaViewSegment(
  pathname: string,
  databaseId: string,
): DatabaseSchemaView | null {
  const prefix = `${databaseSchemaBasePath(databaseId)}/`
  if (!pathname.startsWith(prefix)) return null
  const rest = pathname.slice(prefix.length).replace(/\/$/, '')
  if (rest === 'diagram' || rest === 'table') return rest
  return null
}

export function isDatabaseSchemaPath(pathname: string, databaseId: string): boolean {
  const base = databaseSchemaBasePath(databaseId)
  return pathname === base || pathname.startsWith(`${base}/`)
}
